import React, { Component } from 'react';
import { Text } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';
import { ChiTietDoiTuongThanhTraDialog } from 'modules/dialog';
import { get, isEmpty } from 'lodash';

export default class ThongTinCuocThanhTra extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chiTietDT: false
    }
  }

  componentDidMount() {
    if (this.props.dataCuocThanhTra && this.props.dataCuocThanhTra.dataDetail) {
      this.setState({
        ...this.props.dataCuocThanhTra.dataDetail
      });
    }
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.dataCuocThanhTra && nextProps.dataCuocThanhTra.dataDetail) {
      this.setState({
        ...nextProps.dataCuocThanhTra.dataDetail,
      });
    }
  }

  onOpenDialog() {
    this.setState({
      chiTietDT: true
    });
  }

  toggleDialog() {
    this.setState({
      chiTietDT: false
    });
  }

  render() {
    let DoiTuongThanhTra = '';
    let TenDTTheoKeHoach = '';
    if (this.state.cuocThanhTraNhieuDoiTuong === false && this.state.listDoiTuongThanhTra && this.state.listDoiTuongThanhTra.length > 0) {
      TenDTTheoKeHoach = this.state.listDoiTuongThanhTra[0].ten;
    } else if (this.state.cuocThanhTraNhieuDoiTuong && this.state.listDoiTuongThanhTra.length > 0) {
      TenDTTheoKeHoach = `${this.state.listDoiTuongThanhTra.length} đối tượng`;
    }
    if (this.state.listDoiTuongThanhTra && this.state.listDoiTuongThanhTra.length > 0) {
      this.state.listDoiTuongThanhTra.map((state, index) => {
        if (index == 0) {
          DoiTuongThanhTra = `${DoiTuongThanhTra} ${state.ten}`;
        } else {
          DoiTuongThanhTra = `${DoiTuongThanhTra}; ${state.ten}`;
        }
      })
    }
    return (
      <div className="box-items mb0">
        <div className="box-forward">
          <div className="title">
            <div className="rows">
              <div className="col-12">
                <h3 className="mb15 tt-title">2. Thông tin cuộc {this.props.loaiCuocText}</h3>
              </div>
            </div>
          </div>
          <div className="group-box">
            <div className="items-form mb20">
              <div className="rows">
                <Text label={`Tên cuộc ${this.props.loaiCuocText}:`} className='col pl-5' value={this.state.ten || ''} />
              </div>
            </div>
            <div className="items-form mb20">
              <div className="rows">
                <label className="col-20 pt-label">
                  <span className="val-title-bold">Đối tượng {this.props.loaiCuocText}:</span>
                  <span className="val-content txt-blue txt-underline cursor-pointer txt-inline-block" onClick={this.onOpenDialog.bind(this)}>{TenDTTheoKeHoach}</span>
                </label>
                <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={this.state} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this)} />
              </div>
            </div>
            <div className="items-form mb20">
              <div className="rows">
                <Text label={`Hoạt động ${this.props.loaiCuocText}:`} className='col-20' value={get(this.state.chucNangCuocThanhTraInfo, 'text') || ''} />
                {
                  get(this.state.chucNangCuocThanhTraInfo, 'type') === "CHUYEN_NGANH" &&
                  <Text label={`Hình thức ${this.props.loaiCuocText} chuyên ngành:`} className='col-25' value={get(this.state.hinhThucThanhTraChuyenNganhInfo, 'text') || ''} />
                }
                {
                  get(this.state.chucNangCuocThanhTraInfo, 'type') === "HANH_CHINH" &&
                  <Text label={`Lĩnh vực ${this.props.loaiCuocText}:`} className='col-20' value={!isEmpty(this.state, 'linhVucThanhTraList') ? get(this.state, 'linhVucThanhTraList', []).map((item) => item.text).join(', ') : ''} />
                }
                <Text label='Hoạt động:' className='col-20' value={get(this.state, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'} />
              </div>
            </div>
            <div className="items-form mb20">
              <div className="rows">
                <Text label={`Thời kỳ ${this.props.loaiCuocText}:`} className='col-20' value={this.state.kyThanhTra || ''} />
                <Text label='Thời hạn làm việc(ngày):' className='col-20' value={this.state.thoiHanThanhTra || ''} />
                <Text label='Thời gian tiến hành:' className='col-20' value={this.state.thoiGianTienHanh || ''} />
              </div>
            </div>
            <div className="items-form mb20">
              <div className="rows">
                <Text label={`Nội dung ${this.props.loaiCuocText}:`} className='col pl-5' value={this.state.noiDungThanhTra || ''} />
              </div>
            </div>
            {/* <div className="items-form mb20">
                  <div className="rows">
                    <Text label='Đơn vị chủ trì:' className='col' value={this.state.donViChuTriInfo && this.state.donViChuTriInfo.ten || ''}/>
                  </div>
                </div> */}
            {/* <div className="items-form mb20">
                  <div className="rows">
                    <Text label='Đơn vị phối hợp:' className='col' value={this.state.donViPhoiHop || ''}/>
                  </div>
                </div> */}
            {
              this.props.type !== 'thanhtratrung' && (
                <div className="items-form mb20">
                  <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription disableAttachFile dataShow={this.props.dataCuocThanhTra.listTaiLieuVanThuThongTinCuocThanhTra} />
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/ThongTinCuocThanhTra.jsx